import { GetStreams_streamsV2_entities } from 'api/streams/types/GetStreams';

import { EventMediaItem } from 'components/OrderStream/StreamEventMedia/types';

export const mapInterviewStreamsToEventMedia = (
  streams: GetStreams_streamsV2_entities[] | null | undefined,
  excludeStreamId?: string
): EventMediaItem[] =>
  (streams || [])
    .reduce<EventMediaItem[]>((items, stream) => {
      const storeSlug = stream.store?.slug;

      if (
        !stream.slug ||
        !storeSlug ||
        stream.isHidden ||
        stream.id === excludeStreamId
      ) {
        return items;
      }

      const publisherName =
        stream.store.storeDetails?.storeName ||
        [stream.store.firstName, stream.store.lastName]
          .filter(Boolean)
          .join(' ');

      items.push({
        id: stream.id,
        title: stream.name || publisherName,
        publisherName,
        imageUrl: stream.imageURL,
        scheduledAt: stream.scheduleDateUtc,
        isFree: stream.isFree,
        price: stream.price,
        href: `/${storeSlug}/streams/${stream.slug}`,
      });

      return items;
    }, [])
    .sort(
      (a, b) =>
        new Date(b.scheduledAt).getTime() - new Date(a.scheduledAt).getTime()
    );
